export enum Steps {
	ConfirmationStep = 'ConfirmationStep',
	SchedulePickupStep = 'SchedulePickupStep',
	VideoWalkthroughStep = 'VideoWalkthroughStep',
	CollectionInformationStep = 'CollectionInformationStep',
	MDIConfirmation = 'MDIConfirmation',
	FillCupStep = 'FillCupStep',
	AddTransportMediaStep = 'AddTransportMediaStep',
	ApplyShippingLabelStep = 'ApplyShippingLabelStep',
	SealShippingBoxStep = 'SealShippingBoxStep',
	FinishedStep = 'FinishedStep',
	NotStarted = 'NotStarted',
}

export enum DeliveryCarriers {
	UPS = 'UPS',
	FedEx = 'FedEx',
}
